import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the noisy "ResizeObserver loop completed with undelivered notifications"
// warning. This fires when a ResizeObserver callback triggers another layout
// change in the same frame — the browser logs it but the UI works correctly.
// Chromium and the W3C track this as a benign warning, not a real error.
// Caught at three transports so it never reaches the CRA overlay, devtools red
// banner, or Sentry-style aggregators.
const _isResizeObserverNoise = (msg) =>
  typeof msg === "string" && msg.indexOf("ResizeObserver loop") !== -1;

window.addEventListener("error", (e) => {
  if (_isResizeObserverNoise(e?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (_isResizeObserverNoise(e?.reason?.message || String(e?.reason || ""))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const _origConsoleError = window.console.error;
window.console.error = (...args) => {
  if (args.length && typeof args[0] === "string" && _isResizeObserverNoise(args[0])) return;
  _origConsoleError.apply(window.console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
